module.exports = __webpack_public_path__ + "img/login-left.f30d05c7.svg";